(function(){
  // ---- header scroll state ----
  var header=document.querySelector('.site-header');
  if(header&&header.classList.contains('on-dark')){
    addEventListener('scroll',function(){header.classList.toggle('scrolled',scrollY>60)},{passive:true});
  }
  var toggle=document.querySelector('.menu-toggle');
  if(toggle){toggle.addEventListener('click',function(){document.querySelector('.header-nav').classList.toggle('open')});}

  // ---- reveals ----
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target)}})},{threshold:.12});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});
  } else {document.querySelectorAll('.reveal').forEach(function(el){el.classList.add('visible')});}

  // ---- MOBILE VIDEO KICK: force autoplay on iOS/Android ----
  document.querySelectorAll('video').forEach(function(v){
    v.muted=true; v.defaultMuted=true; v.setAttribute('muted',''); v.playsInline=true;
    v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline',''); v.setAttribute('autoplay','');
    function tryPlay(){ try{ var p=v.play(); if(p&&p.catch){p.catch(function(){});} }catch(e){} }
    tryPlay();
    v.addEventListener('loadeddata',tryPlay);
    v.addEventListener('canplay',tryPlay);
    ['touchstart','scroll','click','pointerdown'].forEach(function(ev){
      addEventListener(ev,function k(){tryPlay();},{once:true,passive:true});
    });
    document.addEventListener('visibilitychange',function(){if(!document.hidden)tryPlay();});
  });

  // ---- COLLECTION RAIL dots ----
  var rail=document.getElementById('collection-rail'), dotsWrap=document.getElementById('rail-dots');
  if(rail&&dotsWrap){
    var cards=rail.querySelectorAll('.rail-card');
    cards.forEach(function(_,i){var d=document.createElement('span');d.className='rail-dot'+(i===0?' active':'');dotsWrap.appendChild(d);});
    var dots=dotsWrap.querySelectorAll('.rail-dot');
    rail.addEventListener('scroll',function(){
      var idx=Math.round(rail.scrollLeft/(rail.scrollWidth/cards.length));
      dots.forEach(function(d,i){d.classList.toggle('active',i===idx);});
    },{passive:true});
  }

  // ---- PRODUCT swipe gallery dots + thumbs ----
  var track=document.getElementById('pdp-track');
  if(track){
    var slides=track.querySelectorAll('.pdp-slide');
    var pdots=document.querySelectorAll('.pdp-dot');
    track.addEventListener('scroll',function(){
      var idx=Math.round(track.scrollLeft/track.clientWidth);
      pdots.forEach(function(d,i){d.classList.toggle('active',i===idx);});
      document.querySelectorAll('.pdp-thumbs button').forEach(function(b,i){b.classList.toggle('active',i===idx);});
    },{passive:true});
    pdots.forEach(function(d,i){d.addEventListener('click',function(){track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});});});
    document.querySelectorAll('.pdp-thumbs button').forEach(function(b,i){b.addEventListener('click',function(){track.scrollTo({left:i*track.clientWidth,behavior:'smooth'});});});
  }

  // ---- SIZE GUIDE modal (supports every .size-guide-link trigger) ----
  var sizeModal=document.getElementById('size-modal');
  var sizeBtns=document.querySelectorAll('.size-guide-link');
  if(sizeModal&&sizeBtns.length){
    sizeBtns.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();sizeModal.classList.add('open');document.body.style.overflow='hidden';});});
    function closeSize(){sizeModal.classList.remove('open');document.body.style.overflow='';}
    sizeModal.addEventListener('click',function(e){if(e.target.classList.contains('size-modal-bg')||e.target.classList.contains('size-close')){closeSize();}});
    addEventListener('keydown',function(e){if(e.key==='Escape')closeSize();});
  }

  // ---- VARIANT matching (swatches + pills -> id/price/image) ----
  var vJson=document.getElementById('product-variants-json');
  if(vJson){
    var variants=[]; try{variants=JSON.parse(vJson.textContent)}catch(e){}
    var idInput=document.getElementById('variant-id'),priceEl=document.getElementById('product-price'),
        atc=document.getElementById('atc-btn'),groups=document.querySelectorAll('.opt-group'),
        stickyPrice=document.querySelector('.sticky-atc .sa-price');
    function money(c){var cur=(priceEl&&priceEl.textContent)||'$';var s=cur.replace(/[\d.,\s]/g,'')||'$';return s+(c/100).toFixed(2);}
    function sel(){var o=[];groups.forEach(function(g,i){var c=g.querySelector('input:checked');o[i]=c?c.value:null;});return o;}
    function update(){
      var s=sel();
      var m=variants.find(function(v){return s.every(function(val,i){return val===null||v.options[i]===val});});
      if(!m){if(atc){atc.disabled=true;atc.textContent=atc.dataset.labelSold;}return;}
      if(idInput)idInput.value=m.id;
      if(priceEl)priceEl.innerHTML=money(m.price);
      if(stickyPrice)stickyPrice.textContent=money(m.price);
      if(atc){atc.disabled=!m.available;atc.textContent=m.available?atc.dataset.labelAdd:atc.dataset.labelSold;}
      groups.forEach(function(g){var lbl=g.querySelector('.opt-selected'),c=g.querySelector('input:checked');if(lbl&&c)lbl.textContent=c.value;});
      // swap gallery to this variant's image (match by exact image id)
      if(m.featured_image&&m.featured_image.id&&track){
        var slidesArr=track.querySelectorAll('.pdp-slide');
        for(var i=0;i<slidesArr.length;i++){
          if(String(slidesArr[i].getAttribute('data-img-id'))===String(m.featured_image.id)){
            track.scrollTo({left:i*track.clientWidth,behavior:'smooth'}); break;
          }
        }
      }
    }
    groups.forEach(function(g){g.querySelectorAll('input[type=radio]').forEach(function(r){r.addEventListener('change',update);});});
    if(groups.length)update();
  }

  // ---- sticky mobile ATC ----
  var sticky=document.querySelector('.sticky-atc'),form=document.querySelector('.product-form');
  if(sticky&&form&&'IntersectionObserver' in window){
    var io2=new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('visible',!e.isIntersecting)})},{threshold:0});
    io2.observe(form);
    var sB=document.getElementById('sticky-atc-btn');
    if(sB)sB.addEventListener('click',function(){form.querySelector('[type=submit]').click()});
  }
})();
